import _ from 'lodash';

export default findDuplicateAssociation;

/**
 * @name find
 * @description Group appointments by target statuses.
 * @param {array} associations The collection to group.
 * @param {array} shopToCheck The statuses to filter by.
 * @param {array} typeToCheck The statuses to filter by.
 * @return {array} duplicateAssociations Returns the grouped collection.
 */
function findDuplicateAssociation(associations, shopToCheck, typeToCheck) {
  let duplicateAssociations =
  _.find(associations.all, function(association) {
    return association.shop.id === shopToCheck &&
    association.type === typeToCheck.toLowerCase();
  });
  return !_.isUndefined(duplicateAssociations);
}



// WEBPACK FOOTER //
// ./utils/find-duplicate-association.js